export interface PlacePrediction {
  place_id: string
  description: string
  structured_formatting: {
    secondary_text
    main_text
  }
}
export default class GoogleMaps {
  // eslint-disable-next-line no-undef
  private autocompleteService: google.maps.places.AutocompleteService
  // eslint-disable-next-line no-undef
  private geocoder: google.maps.Geocoder
  // eslint-disable-next-line no-undef
  private readonly geocoderOK: google.maps.GeocoderStatus = google.maps.GeocoderStatus.OK

  constructor() {
    // eslint-disable-next-line no-undef
    this.autocompleteService = new google.maps.places.AutocompleteService()
    // eslint-disable-next-line no-undef
    this.geocoder = new google.maps.Geocoder()
  }

  // eslint-disable-next-line no-undef
  getPlacePredictions = (options): Promise<google.maps.places.AutocompletePrediction[]> => {
    return new Promise(resolve => {
      this.autocompleteService.getPlacePredictions(options, (suggestions, status) => {
        resolve(status.toString() !== this.geocoderOK.toString() ? [] : suggestions)
      })
    })
  }

  // eslint-disable-next-line no-undef
  geocodeByPlaceId = (placeId): Promise<google.maps.GeocoderResult[]> => {
    return new Promise((resolve, reject) => {
      this.geocoder.geocode({ placeId }, (results, status) => {
        if (status !== this.geocoderOK) {
          reject(status)
        }
        resolve(results)
      })
    })
  }

  // eslint-disable-next-line no-undef
  geocodeByLocation = (location): Promise<google.maps.GeocoderResult[]> => {
    return new Promise((resolve, reject) => {
      this.geocoder.geocode({ location }, (results, status) => {
        if (status !== this.geocoderOK) {
          reject(status)
        }
        resolve(results)
      })
    })
  }

  static isLoaded = () => {
    return typeof window !== 'undefined' && !!window.google
  }
}
